import { DialogObject } from '@/components/dialog/dialog.types';

interface IGetDeleteStepDialogObjectProps {
  action?: () => void;
  toggleVisibility?: () => void;
  resetStepDto?: () => void;
}

export const deleteStepDialogObject = ({ action, toggleVisibility, resetStepDto }: IGetDeleteStepDialogObjectProps): DialogObject => {
  return {
    title: 'settings.dacScenarios.steps.delete.title',
    description: 'settings.dacScenarios.steps.delete.description',
    onHide: () => {
      resetStepDto?.();
    },
    actions: [
      {
        label: 'settings.dacScenarios.steps.delete.delete',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'settings.dacScenarios.steps.delete.cancel',
        onClick: () => {
          toggleVisibility?.();
          resetStepDto?.();
        },
        variant: 'secondary',
      },
    ],
  };
};
